<script lang="ts" module>
	import Modal from "@components/common/Modal.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import type { ComponentProps } from "svelte";
	import { AuthenticationModalKind } from "../../../core/schema/AuthenticationModalKind.js";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { authenticationModalComponentMap } from "./auth-modal/authenticationModalComponentMap.js";

	const authenticationModalHeadingMap: {
		[K in AuthenticationModalKind]: (
			props: ComponentProps<(typeof authenticationModalComponentMap)[K]>,
		) => LocalizedString;
	} = {
		[AuthenticationModalKind.SignIn]: () => ({
			[Locale.cs]: "Přihlášení",
			[Locale.en]: "Sign In",
		}),
		[AuthenticationModalKind.ForgotPassword]: ({ isLegacy }) => ({
			[Locale.cs]: isLegacy === true ? "Obnova účtu ze staršího systému" : "Zapomenuté heslo",
			[Locale.en]: isLegacy === true ? "Legacy system account recovery" : "Forgot password",
		}),
		[AuthenticationModalKind.ConfirmSignUp]: () => ({
			[Locale.cs]: "Potvrzení registrace",
			[Locale.en]: "Confirm registration",
		}),
		[AuthenticationModalKind.PasswordReset]: () => ({
			[Locale.cs]: "Nové heslo",
			[Locale.en]: "Reset password",
		}),
		[AuthenticationModalKind.Register]: () => ({
			[Locale.cs]: "Registrace",
			[Locale.en]: "Sign up",
		}),
		[AuthenticationModalKind.RegisterSuccess]: () => ({
			[Locale.cs]: "Úspěšná registrace",
			[Locale.en]: "Successfully signed up",
		}),
		[AuthenticationModalKind.ResendConfirmationCode]: () => ({
			[Locale.cs]: "Potřebujete nový potvrzovací kód?",
			[Locale.en]: "Need a new confirmation code?",
		}),
	};
</script>

<script lang="ts">
	const { tenant } = getGlobalTemplateProps();

	const heading = $derived.by(() => {
		if (Auth.authenticationModalKind === undefined) {
			return "";
		}

		return authenticationModalHeadingMap[Auth.authenticationModalKind](Auth.props)[tenant.locale];
	});
</script>

<Modal
	{heading}
	show={Auth.authenticationModalKind !== undefined}
	onclose={(): void => {
		Auth.closeAuthenticationModal();
	}}
	class="w-full max-w-116 md:max-w-138 lg:max-w-186"
>
	<div class="contents" data-clarity-mask="true">
		{#if Auth.authenticationModalKind !== undefined}
			{@const Component = authenticationModalComponentMap[Auth.authenticationModalKind]}
			{void (/* @ts-expect-error We cannot handle the component map well */ "")}
			<Component {...Auth.props} />
		{/if}
	</div>
</Modal>
